const API_BASE = process.env.VUE_APP_API_BASE || 'https://signalroom.vip/backend/api.php'

async function request (action, params = {}, method = 'GET', body = null) {
  const url = new URL(API_BASE)
  url.searchParams.set('action', action)
  Object.keys(params).forEach(key => {
    url.searchParams.set(key, params[key])
  })

  const options = { method, headers: {} }
  if (body) {
    options.headers['Content-Type'] = 'application/json'
    options.body = JSON.stringify(body)
  }

  const res = await fetch(url.toString(), options)
  const text = await res.text()

  let json
  try {
    json = JSON.parse(text)
  } catch (e) {
    const snippet = text.replace(/\s+/g, ' ').slice(0, 120)
    throw new Error(
      `API returned non-JSON (HTTP ${res.status}). ` +
      `Ensure backend/api.php is deployed on signalroom.vip. ${snippet}`
    )
  }

  if (json.code !== 0) {
    throw new Error(json.msg || 'Request failed')
  }
  return json.data
}

export function getHome () {
  return request('get_home')
}

export function getQuiz (id) {
  return request('get_quiz', { id })
}

export function submitAnswers (quizId, answers) {
  return request('submit_answers', {}, 'POST', { quiz_id: quizId, answers })
}
